import { HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../components/TableContent';
import { NormalizedDistributionProduct } from '../../../../../../store/managementAnalysis/types';
import { EquityProductsQueryData } from '../../../../../../store/managementAnalysisDetails/selector';
import { AccordionButton } from '../../AccordionButton';
import { LateralProductBar } from '../../LateralProductBar';

import { tableHead } from './constants';
import { PaidCustody } from './PaidCustody';

interface ProductSearchProps {
  item: Utils.ArrayElement<NonNullable<EquityProductsQueryData>>;
  product: NormalizedDistributionProduct;
}

const ProductSearchItem = ({ item, product }: ProductSearchProps) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const renderSecondaryInfo = () => {
    return <PaidCustody item={item} />;
  };

  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent
      direction="column"
      space={Spacing['stack.xxxs']}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}>
      <LateralProductBar backgroundColor={Color[product.color]} />
      <HStack w="full" alignItems="center">
        <TableContentItemColumn flex={getFlex(0)}>
          <TableContentItemText>{item.customerNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(1)}>
          <TableContentItemText>{item.assetNameNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(2)}>
          <TableContentItemText>{item.availableQuantityNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(3)}>
          <TableContentItemText>{item.unavailableQuantityNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(4)}>
          <TableContentItemText>{item.currentPriceNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(5)}>
          <TableContentItemText>{item.averagePriceNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(6)}>
          <HStack justifyContent="space-between">
            <TableContentItemText>{item.valueNormalized}</TableContentItemText>
            <AccordionButton isOpen={isOpen} setIsOpen={setIsOpen} />
          </HStack>
        </TableContentItemColumn>
      </HStack>
      {!!isOpen && renderSecondaryInfo()}
    </TableContent>
  );
};

export default React.memo(ProductSearchItem);
